import api from './api'
import type { ApiResponse, TraceDetailData } from '@/types/trace'

export const getTraceDetail = async (traceId: string): Promise<ApiResponse<TraceDetailData>> => {
  return await api.get(`/traces/${traceId}`)
}